import "./mutual-fund-sections.css";

const STEPS = [
  {
    num: 1,
    icon: "fa-user-plus",
    title: "Create Account",
    desc: "Sign up in minutes and create your account.",
  },
  {
    num: 2,
    icon: "fa-id-card",
    title: "Complete KYC",
    desc: "Verify your identity online with a quick KYC process.",
  },
  {
    num: 3,
    icon: "fa-envelope",
    title: "Receive Login Access",
    desc: "Get your secure login credentials within 24 working hours.",
  },
  {
    num: 4,
    icon: "fa-bullseye",
    title: "Select Investment Goal",
    desc: "Choose your financial goals and risk preference.",
  },
  {
    num: 5,
    icon: "fa-chart-pie",
    title: "Build Portfolio",
    desc: "We recommend the best funds and build your portfolio.",
  },
  {
    num: 6,
    icon: "fa-chart-line",
    title: "Track Performance",
    desc: "Monitor your portfolio and track performance in real-time.",
  },
];

export default function MutualFundSteps() {
  return (
    <section className="mf-steps" id="services">
      <div className="mf-steps-inner">
        <header className="mf-sec-header">
          <p className="mf-sec-eyebrow">YOUR INVESTMENT JOURNEY</p>
          <h2 className="mf-sec-title">Simple Steps to Start Investing</h2>
        </header>

        <ol className="mf-steps-list">
          {STEPS.map((step, i) => (
            <li key={step.num} className="mf-step">
              <span className="mf-step-num">{step.num}</span>
              <div className="mf-step-icon">
                <i className={`fa-solid ${step.icon}`} aria-hidden="true" />
              </div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
              {i < STEPS.length - 1 && (
                <span className="mf-step-line" aria-hidden="true" />
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
